(function () {
  'use strict';

  angular
    .module('baseWiseLayoverReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('baseWiseLayoverReport', {
        url: '/base-wise-layover-report',
        views : {
        	'baseWiseLayoverReportView': {
        		templateUrl: 'base-wise-layover-report/views/base-wise-layover-report.tpl.html',
        		controller: 'BaseWiseLayoverReportCtrl',
        		controllerAs: 'baseWiseLayoverReport'
            }
        }
        
      });
  }
}());
